import { MultiSelect, type MultiSelectProps } from '../ui/MultiSelect';
import { FieldLabel } from './FieldLabel';

export interface MultiSelectFieldProps extends MultiSelectProps {
  required?: boolean;
  optional?: boolean;
  labelVariant?: 'bold' | 'caps';
  /** Figma Step-1 style: label rendered as the trigger placeholder instead of above the field. */
  floating?: boolean;
}

/** MultiSelect with a visible label above it (or floating label-as-placeholder). */
export function MultiSelectField({
  label,
  required = false,
  optional = false,
  labelVariant = 'caps',
  floating = false,
  ...multiSelectProps
}: MultiSelectFieldProps) {
  const placeholder = floating
    ? (multiSelectProps.placeholder ?? `${label}${required ? '*' : ''}`)
    : multiSelectProps.placeholder;

  return (
    <div className="flex flex-col gap-1.5">
      {!floating && (
        <FieldLabel label={label} required={required} optional={optional} variant={labelVariant} />
      )}
      <MultiSelect label={label} {...multiSelectProps} placeholder={placeholder} />
    </div>
  );
}
